import React, { Component, PropTypes } from 'react'

class Answer extends Component {

  render() {
    const { data } = this.props

    if((! data) || (data.goal && ((! data.solution) || data.solution.length === 0))) {
      //uncompleted goal answer
      return this.renderEmpty(false)
    }
    if(data.solution.length === 0){
      //not-yet-started pending answer
      return this.renderEmpty(true)
    }

    var symbols = [],
        solution = data.solution
    for(var index = 0; index < solution.length; index=index+2){
      symbols.push(<i key = { "arrow-" + index } className= { "fa fa-arrow-" + solution[index+1] + " " + solution[index]}></i>)
    }

    return <div className = "commands">
             { symbols }
           </div>
  }

  renderEmpty(isPending) {
    return isPending ? <div className = "commands">solving...</div> :
                       <div className = "commands" />
  }
}

export default Answer


// WEBPACK FOOTER //
// ./components/Answer.js